THEME.common = {
  init: function() {
 
  $themeHtmlBody.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function() {
    $themeHtmlBody.stop().clearQueue();
    is_scrolling_to = false;
    is_scrolling_to_next_post = false;
    is_scrolling_to_prev_post = false;
    theme_status_lazy_load();
  });

  /* ================================
  ===       UPDATE VARS          ====
  =================================== */
  function update_vars(){
    themeDocTop=$themeWin.scrollTop();
    theme_min_menu_appear = theme_get_offset_top(jQuery('#sub_header')) - $themeStripBar.outerHeight();  
    $themeStripBarFixed = jQuery('#strip-bar.strip-bar--position-fixed');
    $themeStripBarSingle = jQuery('#strip-bar.strip-bar--single');
    /* used in single.js */
    singleOffsetTop = themeDocTop + $themeStripBarFixed.outerHeight();
    singleOffsetBottom = themeDocTop + $themeWin.outerHeight();
    if($post_view.length){
    post_viewing = parseInt($post_view.attr('postnumber'));
    }
  }

  /* ================================
  ===  IFRAME                    ====
  =================================== */
  function iframe_load_empty(){
    jQuery('iframe').load(function() {            
    if(jQuery.trim(jQuery(this).contents().find("body").html()) === "") {
      jQuery(this).hide();
    }
    });
  }

  /* ================================
  ===    Back to top             ====
  =================================== */
  function back_to_top_function(){
    $themeHtmlBody.stop().clearQueue();
    is_scrolling_to_next_post = false;
    is_scrolling_to_prev_post = false;
    theme_status_lazy_load();
    $themeHtmlBody.animate({ scrollTop: 0 }, 1000, "swing", function(){
        $themeHtmlBody.stop().clearQueue();
        theme_status_lazy_load();
        $themeWin.trigger("scroll");
    });
  }

  /* ================================
  ===    Track Analytics         ====
  =================================== */
  function click_track_analytics(){
    if (typeof(ga) === 'undefined') {} else {
      var gaCategory = jQuery(this).data('ga-category') || null;
      var gaAction = jQuery(this).data('ga-action') || null;
      var gaLabel = jQuery(this).data('ga-label') || null;
      var gaValue = jQuery(this).data('ga-value') || null;
      gaValue = (typeof(gaValue) === 'number') ? gaValue : null;
      if (gaCategory && gaAction) {
        ga('send', 'event', gaCategory, gaAction, gaLabel, gaValue);
        jQuery('.trackAnalytics').css('pointer-events', 'initial');
        jQuery(this).css('pointer-events', 'none');
      }
    }
  }

  /* ================================
  ===    Clickable class         ====
  =================================== */
  function click_class_clickable(e){
    e.preventDefault();
    e.stopPropagation();
    var $this = jQuery(this);
    if ($this.hasClass('scroll_to') && $this.is('[data-scrollto]') && jQuery($this.data('scrollto')).length > 0) {
      is_scrolling_to = $this;
      var _top = $themeStripBarFixed.height();
      var scroll_to = theme_get_offset_top(jQuery(is_scrolling_to.data('scrollto'))) - _top - 10;
      $themeHtmlBody.animate({
        scrollTop: scroll_to
      }, 1000, "swing", function() {
        $themeHtmlBody.stop().clearQueue();
        // var scroll_to_new=theme_get_offset_top(jQuery($this.data('scrollto'))) - $themeStripBarFixed.height()-10;
        // if(scroll_to_new>scroll_to){ scroll_to($this); }
      });
      theme_status_lazy_load();
    } else if ($this.is('[data-href]') && $this.data('href') !== "#") {
      e.preventDefault();
      e.stopPropagation();
        window.location = $this.data('href');
    }
  }
 
  /* ================================
  ===    MAIN MENU              ====
  =================================== */
  function main_menu_appear() {
      if(themeDocTop >= theme_min_menu_appear){
          if(!$themeStripBar.hasClass('strip-bar--position-fixed')){
            $themeStripBar.addClass('strip-bar--position-fixed');
          }
          if(!theme_is_mobile() || (theme_is_mobile() && $themeStripBar.hasClass('strip-bar--position-fixed') && !$themeStripBar.hasClass('strip-bar--position-fixed-mobile'))){

            if(theme_is_mobile()){
              $themeBody.css('padding-top',$themeStripBar.outerHeight());
              if(!$themeStripBar.hasClass('strip-bar--position-fixed-mobile')){
                $themeStripBar.addClass('strip-bar--position-fixed-mobile');
              }
            } else {
              $themeBody.css('padding-top',"");
            }

          }
      } else {
        $themeBody.css('padding-top',"");
        $themeStripBar.removeClass('strip-bar--position-fixed').removeClass('strip-bar--position-fixed-mobile');
      }
  }

  function click_menu_hamb(e){
    e.preventDefault();
    e.stopPropagation();
    jQuery(".strip-bar__content__menu").removeClass("menu--active--first");
    if (jQuery('.menu--hamb').hasClass('menu--active')) {
      jQuery(".strip-bar__content__menu").removeClass("menu--active");
      jQuery(".strip-bar__content__reader").addClass("menu--active");
      jQuery(".menu--hamb").removeClass("menu--active");
      // $themeHtmlBody.removeClass("lock--position");
      // $themeBody.css('position','').css('top','');
    } else {
      jQuery(".strip-bar__content__reader").removeClass("menu--active");
      jQuery(".strip-bar__content__menu").addClass("menu--active");
      jQuery(".menu--hamb").addClass("menu--active");
      // $themeHtmlBody.addClass("lock--position");
      // $themeBody.css('position','relative').css('top','-'+$themeBody.css('margin-top'));
    }
  }

  function click_close_menu_navigation(e){
    e.preventDefault();
    e.stopPropagation();
    jQuery('.sub-navigation--depth-1').removeClass("theme-submenu--horizontal");
    jQuery('.theme-submenu--active').removeClass("theme-submenu--active");
  }

  /* ================================
  ===       search-form          ====
  =================================== */
  jQuery('a[href="#search"]').on("click", function(event) {
    event.preventDefault();
    jQuery("#search").addClass("open");
    jQuery('#search > form > input[type="search"]').focus();
    $themeHtml.addClass('lock--position');
  });

  jQuery("#search, #search button.close, #search button.close i").on("click keyup", function(event) {
    if (
      event.target === this ||
      event.target.className === "close" ||
      event.target.className === "ion-close-round" ||
      event.keyCode === 27
    ) {
      jQuery(this).removeClass("open");
      $themeHtml.removeClass('lock--position');
    }
  });


  function submit_search_form(){
    if (jQuery.trim(jQuery(this).find('input[type="search"]').val()) === "") {
      return false;
    }
  }

  function owl_slider_block_operators(e){
    jQuery('#block--operators .owl-carousel').owlCarousel({
      loop:true,
        margin:10,
        nav:true,
        navText:["<i class='ion-ios-arrow-back'></i>","<i class='ion-ios-arrow-forward'></i>"],
        responsiveClass:true,
        responsive:{
          0:{
                items:2,
            nav:true,
                loop:true
            },
            736:{
                items:4,
            nav:true,
                loop:true
            }
        }
    });
  }

  /* ==========================================================================================================
  ===  EVENTS  ================================================================================================
  ============================================================================================================= */

  /* == DOCUMENT READY ======================================================================================== */
    addEventListener('message', receiveMessage, false);
    // iframe_load_empty(); /* === IFRAME === */
    theme_init_lazy_load(); /* === lazy-load === */
    update_vars(); /* === UPDATE VARS === */
    main_menu_appear(); /* === MAIN MENU === */
    theme_resize_video(); /* === Resize video container === */
    theme_clone_all(); /* === CLONE ELEMENTS === */
    theme_sticky(); /* === Sticky function element === */
    on_ref_replace(); /* === on=ref replace === */
    // jQuery('[data-toggle="tooltip"]').tooltip(); /* === Bootstrap Tooltip === */
    iframe_resize_fb(); /* === IFRAME === */
    owl_slider_block_operators(); /* === SLIDERS === */
  /* == DOCUMENT READY END ==================================================================================== */

  /* == WINDOW RESIZE ========================================================================================= */
    $themeWin.resize(function() {
      update_vars(); /* === UPDATE VARS === */
      main_menu_appear(); /* === MAIN MENU === */
      theme_resize_video(); /* === Resize video container === */
      theme_sticky(); /* === Sticky function element === */
      iframe_resize_fb(); /* === IFRAME === */
    });
  /* == WINDOW RESIZE END ===================================================================================== */

  /* == WINDOW SCROLL ========================================================================================= */
    $themeWin.scroll(function() {
      update_vars(); /* === UPDATE VARS === */
      main_menu_appear(); /* === MAIN MENU === */
      theme_sticky(); /* === Sticky function element === */
    });
  /* == WINDOW SCROLL END ===================================================================================== */

  /* == DOCUMENT CLICK ======================================================================================== */
    $themeDoc.on('click', '#back-to-top', back_to_top_function); /* === Back to top ==== */
    $themeDoc.on('click', '.trackAnalytics', click_track_analytics); /* === Track Analytics ==== */
    $themeDoc.on('click', '.clickable', click_class_clickable); /* === Clickable class === */
    $themeDoc.on('click', '.menu--hamb', click_menu_hamb);  /* === MAIN MENU === */
    $themeDoc.on('click', '.close-navigation--depth-1', click_close_menu_navigation); /* === MAIN MENU === */
  /* == DOCUMENT CLICK END ==================================================================================== */

  /* == DOCUMENT SUBMIT ======================================================================================= */
    $themeDoc.on('submit', '#search form', submit_search_form); /* === search-form === */
  /* == DOCUMENT SUBMIT END =================================================================================== */

  /* == DOCUMENT LOAD ======================================================================================= */
  $themeDoc.on("load", 'iframe', iframe_resize_fb);
  jQuery('iframe').on("load", iframe_resize_fb);
  /* == DOCUMENT LOAD END =================================================================================== */

  /* == DOCUMENT FOCUS ======================================================================================== */
  /* == DOCUMENT FOCUS END ==================================================================================== */
  
  /* ==========================================================================================================
  ===  EVENTS END =============================================================================================
  ============================================================================================================= */

  },
  finalize: function() {

  }
};
